import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { Helmet } from "react-helmet-async";

import { getListRetail, List } from "~/features/retail";
import { ErrorElement } from "~/components/ErrorElement";

const retailSearchSchema = z.object({
  page: z.number().catch(1),
  limit: z.number().catch(9),
  keyword: z.string().catch(""),
});

type RetailSearch = z.infer<typeof retailSearchSchema>;

export const Route = createFileRoute("/_layout/retail/")({
  validateSearch: (search: Record<string, unknown>): RetailSearch => retailSearchSchema.parse(search),
  loaderDeps: ({ search: { keyword, limit, page } }) => ({ keyword, limit, page }),
  loader: ({ context: { queryClient }, deps: { page, limit, keyword } }) =>
    queryClient.ensureQueryData(getListRetail({ page, limit, keyword })),
  gcTime: 0,
  shouldReload: false,
  errorComponent: () => <ErrorElement statusCode="500" />,
  notFoundComponent: () => <ErrorElement statusCode="404" />,
  component: () => (
    <>
      <Helmet>
        <title>Data Retail - Ecobiz</title>
      </Helmet>
      <List />
    </>
  ),
});
